import "./scripts/search_live";

import "./styles/search_live.scss";
import "./styles/search_results.scss";
